import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Constants } from "Constants";

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  // httpOptions: any;
  constructor(private http: HttpClient) {
    // this.httpOptions = {
    //   headers: new HttpHeaders({
    //     "authorization": localStorage.getItem("access_token")
    //   }),
    // };
  }

  getUsers(page: Number) {
    let pageNO;
    if (page) {
      pageNO = page
    } else {
      pageNO = 1;
    }
    let headers = new HttpHeaders({
      authorization: localStorage.getItem("access_token"),
    });
    let promise = new Promise((resolve, reject) => {
      this.http
        .get(Constants.BASE_URL + "users?page=" + pageNO, { headers })
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            // console.log("Users Fetched");
            // console.log(uploadResponse.data);
            resolve(uploadResponse.data);
          } else {
            reject(uploadResponse.data);
          }
        });
    });
    return promise;
  }
  getSearchUsers(page: Number, search, type) {
    let pageNO;
    if (page) {
      pageNO = page
    } else {
      pageNO = 1;
    }
    let headers = new HttpHeaders({
      authorization: localStorage.getItem("access_token"),
    });
    let promise = new Promise((resolve, reject) => {
      this.http
        .get(Constants.BASE_URL + "users?page=" + pageNO + "&search=" + search + "&type=" + type, { headers })
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            // console.log("Users Fetched");
            // console.log(uploadResponse.data);
            resolve(uploadResponse.data);
          } else {
            reject(uploadResponse.data);
          }
        });
    });
    return promise;
  }
  importUsers(file: File) {
    let headers = new HttpHeaders({
      authorization: localStorage.getItem("access_token"),
    });
    let promise = new Promise((resolve, reject) => {
      let formData: FormData = new FormData();
      formData.append("file", file);
      this.http
        .post(Constants.BASE_URL + "users/import", formData, { headers })
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            // console.log("users upload response");
            // console.log(uploadResponse.data);
            resolve(uploadResponse.data);
          } else {
            reject(uploadResponse.data);
          }
        });
    });
    return promise;
  }

  registerNewUser(body) {

    let promise = new Promise((resolve, reject) => {
      this.http
        .post(Constants.BASE_URL + "users/signup", body)
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            resolve(uploadResponse.data);
          } else {
            reject(uploadResponse.message);
          }
        });
    });
    return promise;

  }

  getInactiveUsers(page: Number) {
    let pageNO;
    if (page) {
      pageNO = page
    } else {
      pageNO = 1;
    }
    let headers = new HttpHeaders({
      authorization: localStorage.getItem("access_token"),
    });
    let promise = new Promise((resolve, reject) => {
      this.http
        .get(Constants.BASE_URL + "users/unapproved?page=" + pageNO + "&limit=5", { headers })
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            // console.log("Users Fetched");
            // console.log(uploadResponse.data);
            resolve(uploadResponse.data);
          } else {
            reject(uploadResponse.message);
          }
        });
    });
    return promise;
  }
  searchInactiveUsers(page: Number, search, type) {
    let pageNO;
    if (page) {
      pageNO = page
    } else {
      pageNO = 1;
    }
    let headers = new HttpHeaders({
      authorization: localStorage.getItem("access_token"),
    });
    let promise = new Promise((resolve, reject) => {
      this.http
        .get(Constants.BASE_URL + "users/unapproved?page=" + pageNO + "&limit=5&search=" + search + "&type=" + type, { headers })
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            // console.log("Users Fetched");
            // console.log(uploadResponse.data);
            resolve(uploadResponse.data);
          } else {
            reject(uploadResponse.message);
          }
        });
    });
    return promise;
  }
  getUserDetail(id) {
    let headers = new HttpHeaders({
      authorization: localStorage.getItem("access_token"),
    });
    let promise = new Promise((resolve, reject) => {
      this.http
        .get(Constants.BASE_URL + "users/" + id, { headers })
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            resolve(uploadResponse.data);
          } else {
            reject(uploadResponse.data);
          }
        });
    });
    return promise;
  }

  getUserDetailByToken(token) {

    let promise = new Promise((resolve, reject) => {
      this.http
        .get(Constants.BASE_URL + "users/token/" + token)
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            resolve(uploadResponse);
          } else {
            reject(uploadResponse);
          }
        });
    });
    return promise;
  }

  updateUserDetail(id, body) {

    let promise = new Promise((resolve, reject) => {
      this.http
        .put(Constants.BASE_URL + "users/" + id, body)
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            resolve(uploadResponse.message);
          } else {
            reject(uploadResponse.message);
          }
        });
    });
    return promise;
  }

  approveUsers(ids) {
    let headers = new HttpHeaders({
      authorization: localStorage.getItem("access_token"),
    });
    let promise = new Promise((resolve, reject) => {
      this.http
        .put(Constants.BASE_URL + "users/approve", { ids: ids }, { headers })
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            resolve(uploadResponse.message);
          } else {
            reject(uploadResponse.message);
          }
        });
    });
    return promise;
  }
  rejectUsers(ids) {
    let headers = new HttpHeaders({
      authorization: localStorage.getItem("access_token"),
    });
    let promise = new Promise((resolve, reject) => {
      this.http
        .put(Constants.BASE_URL + "users/reject", { ids }, { headers })
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            resolve(uploadResponse.message);
          } else {
            reject(uploadResponse.message);
          }
        });
    });
    return promise;
  }
  verifyUser(token) {
    let promise = new Promise((resolve, reject) => {
      this.http
        .get(Constants.BASE_URL + "admin/" + token + "/verifyJWT")
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            // console.log("Users Fetched");
            // console.log(uploadResponse.data);
            resolve(uploadResponse.data);
          } else {
            reject(uploadResponse.data);
          }
        });
    });
    return promise;
  }
  setAsAdmin(body) {
    let headers = new HttpHeaders({
      authorization: localStorage.getItem("access_token"),
    });
    let promise = new Promise((resolve, reject) => {
      this.http
        .post(Constants.BASE_URL + "admin/set", body, { headers })
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            resolve(uploadResponse.message);
          } else {
            reject(uploadResponse.message);
          }
        });
    });
    return promise;

  }

  changePassword() {
    let headers = new HttpHeaders({
      authorization: localStorage.getItem("access_token"),
    });
    let promise = new Promise((resolve, reject) => {
      this.http
        .post(Constants.BASE_URL + "admin/change/password", {}, { headers })
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            resolve(uploadResponse.message);
          } else {
            reject(uploadResponse.message);
          }
        });
    });
    return promise;

  }
  getSetuStatus() {
    let headers = new HttpHeaders({
      authorization: localStorage.getItem("access_token"),
    });
    let promise = new Promise((resolve, reject) => {
      this.http
        .get(Constants.BASE_URL + "admin/bot", { headers })
        .subscribe((res) => {
          let uploadResponse = JSON.parse(JSON.stringify(res));
          if (uploadResponse.code === 200) {
            // console.log("Users Fetched");
            // console.log(uploadResponse.data);
            resolve(uploadResponse.data);
          } else {
            reject(uploadResponse.message);
          }
        });
    });
    return promise;
  }

  exportUsers() {
    let headers = new HttpHeaders({
      authorization: localStorage.getItem("access_token"),
    });
    let promise = new Promise((resolve, reject) => {
      this.http
        .get(Constants.BASE_URL + "users/export", { headers, responseType: 'arraybuffer' })
        .subscribe((res: any) => {
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const element = document.createElement('a');
          element.href = window.URL.createObjectURL(blob);
          element.download = "JITO_USERS.xlsx";
          element.click();
          // window.open(element.href, element.download)
          resolve("File SuccessFully Downloded");
        });
    });
    return promise;

  }
  exportNonApprovedUsers() {
    let headers = new HttpHeaders({
      authorization: localStorage.getItem("access_token"),
    });
    let promise = new Promise((resolve, reject) => {
      this.http
        .get(Constants.BASE_URL + "users/unapproved/export", { headers, responseType: 'arraybuffer' })
        .subscribe((res: any) => {
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const element = document.createElement('a');
          element.href = window.URL.createObjectURL(blob);
          element.download = "JITO_NonApproved_USERS.xlsx";
          element.click();
          // window.open(element.href, element.download)
          resolve("File SuccessFully Downloded");
        });
    });
    return promise;

  }

}
export class Notifier {
  valueChanged: () => void = () => { };
}